import { CardAdminInfo } from "./card-admin";
import { IPerson, PERSON_ACTIVE_STATUS } from "./person";

export enum VALORFRETECAMPO {
  NAO_DEVOLVER = 1,
  PROPRIO = 2,
  DESPESAS = 3,
  PROPRIO_SEM_BC = 4
}

export enum DEVOLUCAO_ICMSST {
  /**
   * Não realiza tratamento
   * @default
   */
  NAO_TRATAR = 1,

  /** Soma ao valor do produto e lista nos dados adicionais da nota */
  SOMAR_PRODUTO = 2,

  /** Soma ao valor de despesas e lista nos dados adicionais da nota */
  SOMAR_DESPESAS = 3,

  NAO_DEVOLVER = 4
}

export enum DEVOLUTION_OTHERS {
  DO_NOT_DEVOLVE = 1,
  DEVOLVE_AND_NOT_SUM_BC = 2,
  DEVOLVE_AND_SUM_BC = 3
}

export enum DEVOLUTION_IPI_STRATEGY {
  NAO_DESTACAR = "NAO_DESTACAR",
  DESTACAR_IPI_DEVOLVIDO = "DESTACAR_IPI_DEVOLVIDO"
}

export interface DevolutionConfig {
  freightField: VALORFRETECAMPO;
  icmsStField: DEVOLUCAO_ICMSST;
  detachOtherExpenses: DEVOLUTION_OTHERS;
  includeICMSDeson: boolean;
  IPI: DEVOLUTION_IPI_STRATEGY;
}

export const DEFAULT_DEVOLUTION_IPI_STRATEGY = DEVOLUTION_IPI_STRATEGY.DESTACAR_IPI_DEVOLVIDO;

export function normalizeDevolutionConfig(
  config: Partial<DevolutionConfig> | undefined,
  includeICMSDeson = false
): DevolutionConfig {
  return {
    freightField: config?.freightField ?? VALORFRETECAMPO.NAO_DEVOLVER,
    icmsStField: config?.icmsStField ?? DEVOLUCAO_ICMSST.NAO_TRATAR,
    detachOtherExpenses: config?.detachOtherExpenses ?? DEVOLUTION_OTHERS.DO_NOT_DEVOLVE,
    includeICMSDeson: config?.includeICMSDeson ?? includeICMSDeson,
    IPI: config?.IPI ?? DEFAULT_DEVOLUTION_IPI_STRATEGY,
  };
}

/** Freight and ICMS-ST can only be moved to other expenses when other expenses are highlighted */
export function isOtherExpensesTargetDisabled(config: Partial<DevolutionConfig> | undefined): boolean {
  return config?.detachOtherExpenses == DEVOLUTION_OTHERS.DO_NOT_DEVOLVE;
}

/** Other expenses must stay highlighted while freight or ICMS-ST is moved to them */
export function isDoNotDevolveOtherExpensesDisabled(config: Partial<DevolutionConfig> | undefined): boolean {
  return config?.freightField == VALORFRETECAMPO.DESPESAS || config?.icmsStField == DEVOLUCAO_ICMSST.SOMAR_DESPESAS;
}

export interface Supplier extends IPerson {
  profession?: string;
  cardAdmin?: CardAdminInfo[]
  // cardAdmin?: { tax: number, portion: number }[];
  documentType?: number;

  isTransporter?: boolean;

  /** rg or stateRegistration */
  rg?: string;
  insMun?: string;
  /**
   * @todo
   */
  fancyName?: string;
  creditCrad?: string
  deditCrad?: string

  freightField?: VALORFRETECAMPO;
  devolutionConfig?: Partial<DevolutionConfig>;
  active?: PERSON_ACTIVE_STATUS;
}
